import { useState, FormEvent } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { SelectOption } from "@idw-types/common";
import { DefaultModal } from "@containers/common/modals/default-modal/default-modal";
import { ButtonWithSpinner } from "@containers/common/button-with-spinner/button-with-spinner";
import { resources } from "@constants/hardcoded-strings";
import { LabelWidthTypes } from "@enums/label-width-types";
import { ButtonTypes } from "@enums/button-types";
import { SelectFormGroup } from "@containers/common/select-form-group/select-form-group";

type AddRelyingPartyRoleModalProps = {
    onModalClose: () => void;
    addRelyingPartyRole: (
        relyingPartyId: string,
        propertyBundleShortName: string
    ) => void;
    relyingPartyOptions: Array<SelectOption>;
    userPropertyBundleOptions: Array<SelectOption>;
};

type AddRelyingPartyRoleModalState = {
    selectedRelyingParty: SelectOption;
    selectedUserPropertyBundle: SelectOption;
};

export const AddRelyingPartyRoleModal = (props: AddRelyingPartyRoleModalProps) => {
    const {
        onModalClose,
        addRelyingPartyRole,
        relyingPartyOptions,
        userPropertyBundleOptions
    } = props;

    const [labelWidth] = useState(LabelWidthTypes.MEDIUM);
    const [state, setState] = useState<AddRelyingPartyRoleModalState>({
        selectedRelyingParty: relyingPartyOptions.length === 1 ? relyingPartyOptions[0] : null,
        selectedUserPropertyBundle: null
    });

    const handleSubmit = async (event: FormEvent) => {
        event.preventDefault();
        addRelyingPartyRole(
            state.selectedRelyingParty.value,
            state.selectedUserPropertyBundle.value
        );
        onModalClose();
    };

    const handleUpdateRelyingParty = (newValue: SelectOption) => {
        if (newValue) {
            setState({
                ...state,
                selectedRelyingParty: newValue
            });
        }
    };

    const handleUpdateRole = (newValue: SelectOption) => {
        if (newValue) {
            setState({
                ...state,
                selectedUserPropertyBundle: newValue
            });
        }
    };

    return (
        <DefaultModal
            automationId="add-relying-party-role-modal"
            ariaLabelledBy="add-relying-party-role-modal-title"
            onHide={onModalClose}
            backdrop={"static"}
            keyboard={false}
            isMaxWidth={false}
        >
            <Form onSubmit={handleSubmit}>
                <Modal.Header id={"add-relying-party-role-modal-title"} closeButton>
                    <Modal.Title>{resources.modals.addRelyingPartyRole.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <SelectFormGroup
                        controlId={`add-relying-party-role-rp-select`}
                        label={resources.common.inputs.relyingParty.label}
                        ariaLabel={resources.common.inputs.relyingParty.label}
                        automationId={`add-relying-party-role-rp-select`}
                        onChange={handleUpdateRelyingParty}
                        options={relyingPartyOptions}
                        selectedOption={state.selectedRelyingParty}
                        disabled={relyingPartyOptions.length === 1}
                        isRequired={true}
                        isSearchable={true}
                        isClearable={false}
                        labelWidth={labelWidth}
                    />
                    <SelectFormGroup
                        controlId={`add-relying-party-role-role-select`}
                        label={resources.common.inputs.role.label}
                        ariaLabel={resources.common.inputs.role.label}
                        automationId={`add-relying-party-role-role-select`}
                        onChange={handleUpdateRole}
                        options={userPropertyBundleOptions}
                        selectedOption={state.selectedUserPropertyBundle}
                        disabled={false}
                        isRequired={true}
                        isSearchable={true}
                        isClearable={false}
                        labelWidth={labelWidth}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button id="add-relying-party-role-cancel-button" variant="secondary" onClick={onModalClose}>
                        {resources.common.buttons.cancel.label}
                    </Button>
                    <ButtonWithSpinner
                        id="add-relying-party-role-save-button"
                        disabled={false}
                        hideSpinner={true}
                        variant="primary"
                        type={ButtonTypes.SUBMIT}
                        label={resources.common.buttons.save.label}
                    />
                </Modal.Footer>
            </Form>
        </DefaultModal>
    );
};